module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[21]264.8e5624f.woff2";